<template>
  <div class="RecruitInfo">
    <div class="module">

      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="急招岗位" name="hours"></el-tab-pane>
        <el-tab-pane label="最新职位" name="news"></el-tab-pane>
      </el-tabs>
      
      <div class="position-info">
        <div class="position-info-item hastily" v-for="(item, index) in hotjoblist" :key="index" v-show="activeName == 'hours'" @click="gotoDetails(item.jobinnerid)">
          <div class="card">
            <p class="title">
              <span class="position-name">{{item.jobname}}</span>
              <span class="time">[{{item.lastupdatetime}}]</span>
              <span class="year-money">{{item.salarytext}}</span>
            </p>
            <p class="company">{{item.companydisplayname}}</p>
            <div class="hr"></div>
            <p class="msg-info">
              <span>{{item.jobplace}}</span>
              <span>{{item.industryname}}</span>
              <span>{{item.exptypename}}</span>
              <span class="moreinfo">查看详情</span>
            </p>
          </div>
        </div>

        <div class="position-info-item" v-for="(item, index) in newjoblist" :key="'news'+index" v-show="activeName == 'news'" @click="gotoDetails(item.jobinnerid)">
          <div class="card">
            <p class="title">
              <span class="position-name">{{item.jobname}}</span>
              <span class="time">[{{item.lastupdatetime}}]</span>
              <span class="year-money">{{item.salarytext}}</span>
            </p>
            <p class="company">{{item.companydisplayname}}</p>
            <div class="hr"></div>
            <p class="msg-info">
              <span>{{item.jobplace}}</span>
              <span>{{item.industryname}}</span>
              <span>{{item.exptypename}}</span>
              <span class="moreinfo">查看详情</span>
            </p>
          </div>
        </div>

      </div>

      <el-button class="more" type="primary" plain @click="goto">查看更多</el-button>
    </div>
  </div>
  <!-- end 招聘信息 -->
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'RecruitInfo',
  props: ['hotjoblist', 'newjoblist'],  // 热门职位 最新职位
  data () {
    return {
      activeName: 'hours' // 菜单切换
    }
  },
  mounted () {
    this.$nextTick(() => {
      
    })
  },
  methods: {
    gotoDetails (jobid) {
            const {href} = this.$router.resolve({
                name: "JobInfo",
                query: {jobid: jobid}
            })
            window.open(href, '_blank')
    },
    goto() {
      this.$router.push({name: "TalentSearch"})
    },
    handleClick(tab) { // 切换菜单栏事件
      this.activeName = tab.name
    },
    ...mapActions([
      'setLoading'
    ])
  },
  filters: {},
  watch: {
  },
  computed: {
    ...mapGetters([
        'user'
    ])
  },
  components: {
      
  }
}
</script>

<style lang="scss" type="text/scss" >

.RecruitInfo {
  padding-top: 60px;
  padding-bottom: 40px;
  background: #fff;

  .el-tabs__nav-wrap::after {
    height: 1px;
  }
  .more {
    clear: both;
    display: block;
    margin: auto;
    margin-top: 30px;
    width:260px;
  }

  .position-info {
    margin-left: -15px;
    min-height: 332px;
    
    .position-info-item {
      position: relative;
      float: left;
      box-sizing: border-box;
      margin-top: 15px;
      margin-left: 15px;
      width:390px;
      height:150px;
      background:rgba(255,255,255,1);

      &.hastily::before {
        content: '';
        position: absolute;
        display: block;
        width: 38px;
        height: 38px;
        left: 0;
        right: 0;
        background: url('../../../../common/images/talent/index/hastily.png') no-repeat;
        background-size: 38px;
      }

      .card {
        position: absolute;
        padding: 30px 20px;
        box-sizing: border-box;
        width:390px;
        height:150px;
        border:1px solid rgba(229,229,229,1);
        transition: all .5s;
        -webkit-transition: all .5s;
        -ms-transition: all .5s;
        -moz-transition: all .5s;
        -o-transition: all .5s;
        cursor: pointer;

        .title {
          height: 22px;
          line-height: 22px;
          span {
            float: left;
          }
          .position-name {
            font-size: 16px;
            color: #2B5278;
            max-width: 200px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
          .time {
            margin-left: 6px;
            font-size: 14px;
            color: #999;
          }
          .year-money {
            float: right;
            font-size: 16px;
            color: #FF7F04;
          }
        }
        .company {
            margin-top: 10px;
            color: #666666;
            font-size: 14px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
        }
        .hr {
          display: block;
          margin: 12px 0 17px 0;
          // height: 1px;
          border-top: dashed 1px #e5e5e5;
          width: 100%;
          // background: #e5e5e5;
        }

        .msg-info {
          span {
            float: left;
            margin-top: 6px;
            padding: 0 20px;
            color: #666666;
            font-size: 14px;
            border-left: 1px #E5E5E5 solid;
            &:nth-child(1) {
              padding-left: 0;
              border-left: none;
            }
          }
          span:nth-of-type(2) {
            padding: 0 10px;
            max-width: 90px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
          .moreinfo {
            float: right;
            margin-top: 0;
            padding: 0;
            width:82px;
            height:28px;
            line-height: 28px;
            text-align: center;
            font-size: 14px;
            color: #2E7FFF;
            box-sizing: border-box;
            background:rgba(255,255,255,1);
            border-radius:2px;
            border:1px solid rgba(46,127,255,1);

          }
        }

        &:hover {
          box-shadow:0px 2px 11px 0px rgba(132,132,132,0.5);
          -ms-box-shadow:0px 2px 11px 0px rgba(132,132,132,0.5);
          -moz-box-shadow:0px 2px 11px 0px rgba(132,132,132,0.5);
          -o-box-shadow:0px 2px 11px 0px rgba(132,132,132,0.5);
          -webkit-box-shadow:0px 2px 11px 0px rgba(132,132,132,0.5);
        }
      }

    }

  }

}
</style>